module.exports = __webpack_public_path__ + "static/media/2.105c0842.png";